import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { NotificationType, SnackbarData } from 'src/app/services/snackbar-service/snackbar.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-logs-snackbar',
  imports: [
    CommonModule,
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
    MatIconModule
  ],
  templateUrl: './logs-snackbar.component.html',
  styleUrl: './logs-snackbar.component.scss'
})
export class LogsSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);

  // Expose NotificationType enum to the template
  notificationTypes = NotificationType;

  get message(): string {
    return this.data.message;
  }

  get button(): string {
    return this.data.button || 'Ok';
  }

  get type(): NotificationType {
    return this.data.type || NotificationType.INFO;
  }

  get icon(): string {
    return this.data.icon || 'info';
  }
}
